import React from "react";

const IMAGES = [
  {
    url: "/gallery/work-1.jpg",
    label: "Recent project",
    span: "md:col-span-7 md:row-span-2",
    aspect: "aspect-[4/5] md:aspect-auto",
  },
  {
    url: "/gallery/work-2.jpg",
    label: "Recent project",
    span: "md:col-span-5",
    aspect: "aspect-[4/3]",
  },
  {
    url: "/gallery/work-7.jpg",
    label: "Recent project",
    span: "md:col-span-5",
    aspect: "aspect-[4/3]",
  },
  {
    url: "/gallery/work-6.jpg",
    label: "Recent project",
    span: "md:col-span-12",
    aspect: "aspect-[16/7]",
  },
  {
    url: "/gallery/work-3.jpg",
    label: "Recent project",
    span: "md:col-span-4",
    aspect: "aspect-[4/3]",
  },
  {
    url: "/gallery/work-5.jpg",
    label: "Recent project",
    span: "md:col-span-4",
    aspect: "aspect-[4/3]",
  },
  {
    url: "/gallery/work-4.jpg",
    label: "Recent project",
    span: "md:col-span-4",
    aspect: "aspect-[4/3]",
  },
];

export const Gallery = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 sm:py-32 px-6 sm:px-10 lg:px-14"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
          <div>
            <span className="text-xs uppercase tracking-[0.22em] font-semibold text-brand-terracotta">
              Recent work
            </span>
            <h2
              data-testid="gallery-heading"
              className="mt-3 font-display font-bold text-brand-moss-deep text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
            >
              A few of our<br />proudest patches.
            </h2>
          </div>
          <p className="max-w-sm text-brand-charcoal/80 leading-relaxed">
            Real gardens, real customers — every project leaves us (and the customer)
            grinning.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 lg:gap-5 auto-rows-[220px]">
          {IMAGES.map((img, i) => (
            <figure
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`group relative rounded-3xl overflow-hidden bg-brand-sand-2 ${img.span} ${img.aspect}`}
              style={{ minHeight: "220px" }}
            >
              <img
                src={img.url}
                alt={img.label}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-moss-deep/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <figcaption className="absolute bottom-5 left-5 right-5 text-white text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity translate-y-2 group-hover:translate-y-0 duration-300">
                {img.label}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
